import Firebase from './firebase_setup.js';

const auth = Firebase.auth();
export default auth;